import { Link } from 'react-router-dom';
import styles from './PublicShare.module.css';

export function PublicShareLayout({ children, theme = 'cinematic', eyebrow = 'Aluvo Trophy Case' }) {
    return (
        <main className={`${styles.page} ${styles[theme]}`}>
            <div className={styles.aura} />
            <section className={styles.shell}>
                {/*<div className={styles.brandRow}>*/}
                {/*    <Link to="/" className={styles.brand}>◎ Aluvo</Link>*/}
                {/*    <span className={styles.eyebrow}>{eyebrow}</span>*/}
                {/*</div>*/}
                {children}
            </section>
        </main>
    );
}

export function PublicPageCTA({ title, text, buttonText = 'Create your Aluvo profile', to = '/register' }) {
    return (
        <div className={styles.ctaPanel}>
            <div>
                <p className={styles.ctaKicker}>Start your trophy case</p>
                <h2>{title}</h2>
                <p>{text}</p>
            </div>
            <Link to={to} className={styles.primaryAction}>{buttonText}</Link>
        </div>
    );
}

export function EmptyShareState({ icon = '🪙', title, message }) {
    return (
        <PublicShareLayout>
            <div className={styles.emptyState}>
                <span>{icon}</span>
                <h1>{title}</h1>
                <p>{message}</p>
                <Link to="/" className={styles.primaryAction}>Explore Aluvo</Link>
            </div>
        </PublicShareLayout>
    );
}
